import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  Collapse,
  Icon,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useDisclosure,
  Image,
  Tag,
  TagLeftIcon,
  TagLabel,
  HStack,
  StackDivider
} from '@chakra-ui/react';
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons';
import logo from '../../assets/images/logo.png';
import { HiOutlineMail, HiOutlinePhone, HiChevronDown } from 'react-icons/hi'
import { AiFillYoutube } from 'react-icons/ai'
import { FaFacebookF, FaTwitter, FaGooglePlusG, FaLinkedinIn, FaInstagram } from 'react-icons/fa'
import { Link as ReactLink } from 'react-router-dom';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import AuditReport2015 from '../../assets/images/reports/AuditReport2015.pdf'
import { GET } from '../../utilities/ApiProvider';
import { baseUrl } from '../../utilities/customUrls.js'

export default function Header() {
  const navigate = useNavigate();
  const { isOpen, onToggle } = useDisclosure();
  const [TopHeadLinks, setTopHeadLinks] = useState([FaFacebookF, AiFillYoutube])
  const [TopHeadLinkUrl, setTopHeadLinkUrl] = useState(['https://www.facebook.com/MASWTInternational?mibextid=LQQJ4d', 'https://youtube.com/@mujaddidalfsaniwelfaretrus4003', '/', '/', '/'])
  const infocss = {
    color: '#fff',
    fontSize: '13px',
    fontWeight: '400',
  }

  const [auditDynamicLinks, setAuditDynamicLinks] = useState([]);
  const [taxDynamicLinks, setTaxDynamicLinks] = useState([]);

  const [totalNavItems1, setTotalNavItems1] = useState([
    {
      Title: 'Home',
      Id: '/',
    },
    {
      Title: 'About Us',
      children: [
        {
          Name: 'Introduction',
          Id: '/about',
        },
        {
          Name: 'Chairman Message',
          Id: '/about/chairman',
        },
        {
          Name: 'Philosophy',
          Id: '/about/philosophy',
        },
        {
          Name: 'Vision',
          Id: '/about/vision',
        },

      ],
      icon: HiChevronDown
    },
  ])
  const [totalNavItems2, setTotalNavItems2] = useState([
    {
      Title: 'Services',
      children: [],
      icon: HiChevronDown,
    },
  ])
  const [totalNavItems3, setTotalNavItems3] = useState([
    {
      Title: 'Future Projects',
      // children: [
      //   {
      //     Title: 'Hifz / Nazra',
      //     Id: '/services/hifz-nazra',
      //   },
      //   {
      //     Title: 'Qaida / Schooling',
      //     Id: '/services/qaida-schooling',
      //   },
      //   {
      //     Title: 'Dars-e-nazami',
      //     Id: '/services/dars-e-nizami',
      //   },
      //   {
      //     Title: 'Family Adoption',
      //     Id: '/services/family-adoption',
      //   },
      //   {
      //     Title: 'Collective Qurbani',
      //     Id: '/services/collective-qurbani',
      //   },
      //   {
      //     Title: 'Tajheez-o-takfeen',
      //     Id: '/services/tajheez-o-takfeer',
      //   },
      //   {
      //     Title: 'Nai Zindagi',
      //     Id: '/services/nai-zindagi',
      //   },
      //   {
      //     Title: 'Dastarkhwan',
      //     Id: '/services/darterkhwan',
      //   },
      //   {
      //     Title: 'Provide Rashan',
      //     Id: '/services/ration',
      //   },
      //   {
      //     Title: 'Eid Package',
      //     Id: '/services/eid-package',
      //   },
      //   {
      //     Title: 'Ramadhan Package',
      //     Id: '/services/ramadhan-package',
      //   },
      //   {
      //     Title: 'Renovate Masjid/Islami School',
      //     Id: '/services/renovate-masjid',
      //   },
      //   {
      //     Title: 'RO Plant',
      //     Id: '/services/ro-plant',
      //   },
      //   {
      //     Title: 'Online Istekhara',
      //     Id: '/services/istekhara',
      //   },
      //   {
      //     Title: 'Online Sadaqah',
      //     Id: '/services/saqaqah',
      //   },
      //   {
      //     Title: 'Aqiqah',
      //     Id: '/services/Aqiqah',
      //   },
      // ],
      // icon: HiChevronDown
      Id: '/all-services'
    },
  ])
  const [totalNavItems4, setTotalNavItems4] = useState([
    {
      Title: 'Audit Reports',
      Id: '/audit-reports'
      // icon: HiChevronDown
    },
    {
      Title: 'Tax Docs',
      Id: '/tax-docs'
      // icon: HiChevronDown
    },
    {
      Title: 'Media',
      children: [
        {
          Name: 'Photo Gallery',
          Id: '/media/photo-gallery',
        },
        {
          Name: 'Video Gallery',
          Id: '/media/video-gallery',
        },
        {
          Name: 'Press Releases',
          Id: '/media/press-release',
        },
        // {
        //   Name: 'Photo Releases',
        //   Id: '/',
        // },
        {
          Name: 'Downloads',
          Id: '/downloads',
        },
      ],
      icon: HiChevronDown
    },
    {
      Title: 'News',
      Id: '/news',
    },
    {
      Title: 'Donate',
      children: [
        {
          Name: 'Donate Online Now',
          Id: '/online-donate',
        },
        // {
        //   Name: 'Donate From UK',
        //   Id: '/uk-donors',
        // },
        {
          Name: 'Bank Details',
          Id: '/wire-transfer',
        },
        {
          Name: 'Cash & Cross Cheque',
          Id: '/cashAndCheque',
        },
      ],
      icon: HiChevronDown
    },
    {
      Title: 'Contact us',
      Id: '/contact'
    },
  ])

  const getServicesLinks = async () => {
    let auditLinks = await GET(`${baseUrl}/Services`,
      { authorization: `Basic ${btoa('admin:admin123')}` })
    console.log("auditLinks", auditLinks);
    setTotalNavItems2([
      {
        Title: 'Services',
        children: auditLinks?.Data,
        icon: HiChevronDown,
      },
    ])

    let taxLinks = await GET(`${baseUrl}/FutureProject`,
      { authorization: `Basic ${btoa('admin:admin123')}` })
    // console.log(taxLinks);
    setTotalNavItems3([
      {
        Title: 'Future Projects',
        children: taxLinks?.Data,
        icon: HiChevronDown,
      }
    ])
  }

  useEffect(() => {
    getServicesLinks()
  }, [])

  return (
    <Box w={'full'} id='Header'>
      <Flex display={{ base: 'none', lg: 'flex' }} justifyContent={'space-between'} className='top-nav' bg={'#233F4D'} w='full' py={{ base: 2, md: 2, }} px={{ base: 4, md: 30 }}>
        <HStack spacing={6}>
          {/* <Tag size={'lg'} variant='subtle' bg={'transparent'} color={'white'}>
            <TagLeftIcon boxSize='18px' as={AiOutlineClockCircle} color={'#1FBDD0'} />
            <TagLabel><Link sx={infocss} as={ReactLink} to={'/'}>Mon – Fri: 9AM - 8PM, Sat: 9AM - 5PM, Sun (OFF)</Link></TagLabel>
          </Tag>
          <Tag size={'lg'} variant='subtle' bg={'transparent'} color={'white'}>
            <TagLeftIcon boxSize='18px' as={HiOutlineMail} color={'#1FBDD0'} />
            <TagLabel><Link sx={infocss} as={ReactLink} to={'/'}>info@mujaddidalifsani.com</Link></TagLabel>
          </Tag>
          <Tag size={'lg'} variant='subtle' bg={'transparent'} color={'white'}>
            <TagLeftIcon boxSize='18px' as={HiOutlinePhone} color={'#1FBDD0'} />
            <TagLabel><Link sx={infocss} as={ReactLink} to={'/'}>00447972377903, 00923002230155</Link></TagLabel>
          </Tag> */}

        </HStack>
        <HStack
          spacing={'4'}
        // divider={<StackDivider alignSelf={'auto'} borderColor={'#999'} h={'35%'} />}
        >
          {
            TopHeadLinks.map((v, i) => {
              return (
                <a href={TopHeadLinkUrl[i]} style={{ color: '#fff' }} target={'_blank'} key={i} ><Icon as={v} /></a>
              )
            })
          }
        </HStack>

      </Flex>

      <Stack
        direction={{ base: "row-reverse", xl: 'row' }}
        bg={useColorModeValue('#1FBDD0', '#1FBDD0')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        // py={{ base: 4, md: 6 }}
        px={{ base: 0, md: 0 }}
        pr={{ base: 4, md: 30 }}
        boxShadow={'base'}
        align={'center'}
        justifyContent={'space-between'}
      >

        <Flex
          ml={{ base: -2 }}
          zIndex={99}
          position={'relative'}
          display={{ base: 'flex', xl: 'none' }}>
          <IconButton
            id='hamb'
            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={'ghost'}
            color={'#fff'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>

        <Box
          paddingX={8}
          margin={'0 !important'}
        >
          <Box as={ReactLink} to={'/'} position={'absolute'} top={0} zIndex={1}>
            <Image alt={'Logo'} src={logo} draggable={false}
              marginLeft={"-35px"}
              marginTop={"-15px"}
              zIndex={'1 !important'}
              w={{ base: '370px', md: '370px', '2xl': '370px' }}
            />
          </Box>
        </Box>

        <Flex justify={{ base: 'center', md: 'center' }} display={{ base: 'none', xl: 'flex' }}>


          <Flex justify={'center'} display={{ base: 'none', xl: 'flex' }} ml={10}>
            <DesktopNav totalNavItems1={totalNavItems1} totalNavItems2={totalNavItems2} totalNavItems3={totalNavItems3} totalNavItems4={totalNavItems4} />
          </Flex>
        </Flex>

        {/* <Stack
          justify={'flex-end'}
          direction={'row'}
          spacing={6}>
        </Stack> */}
      </Stack>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav totalNavItems1={totalNavItems1} totalNavItems2={totalNavItems2} totalNavItems3={totalNavItems3} totalNavItems4={totalNavItems4} />
      </Collapse>
    </Box>
  );
}

const DesktopNav = ({ totalNavItems1, totalNavItems2, totalNavItems3, totalNavItems4, auditDynamicLinks }) => {
  // console.log(totalNavItems1);
  // console.log(totalNavItems2);
  // console.log(totalNavItems3);
  // console.log(totalNavItems4);
  const linkColor = useColorModeValue('#fff', '#fff');
  const linkHoverColor = useColorModeValue('gray.800', 'white');
  const popoverContentBgColor = useColorModeValue('white', 'gray.800');

  return (
    <Stack direction={'row'} spacing={4}>
      {totalNavItems1?.map((navItem, i) => (
        <Box key={navItem.Title}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Link
                p={{ base: 1 }}
                py={{ base: 5 }}
                as={ReactLink}
                to={navItem.Id ?? '#'}
                fontSize={{ base: '12px', xl: '12px', '2xl': '15px' }}
                fontWeight={500}
                color={linkColor}
                transition={'0.3s ease-in-out'}
                position={'relative'}
                fontFamily={'Poppins'}
                _hover={{
                  color: '#fff',
                  _before: {
                    transform: 'scaleX(1)',
                    transformOrigin: 'bottom left',
                  }
                }}
                _before={{
                  content: `""`,
                  position: 'absolute',
                  w: '100%',
                  h: '2px',
                  transform: 'scaleX(0)',
                  bottom: '10px',
                  left: '0px',
                  borderRadius: '25px',
                  backgroundColor: "#fff",
                  transformOrigin: 'bottom right',
                  transition: 'transform 0.3s ease-in-out'
                }}>
                {navItem.Title}
                {
                  navItem?.icon &&
                  <Icon as={navItem?.icon} marginBottom={'-0.5'} />
                }
              </Link>
            </PopoverTrigger>

            {navItem.children?.length > 0 && (
              <PopoverContent
                className={`${navItem.Title}custom`}
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={2}
                rounded={'base'}
                minW={'base'}>
                <Stack>
                  {navItem.children?.map((child) => (
                    <DesktopSubNav subKey={i} key={child.Title} {...child} project={'simple'} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
      {totalNavItems2?.map((navItem, i) => (
        <Box key={navItem.Title}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Link
                p={{ base: 1 }}
                py={{ base: 5 }}
                as={ReactLink}
                to={navItem.Id ?? '#'}
                fontSize={{ base: '12px', xl: '12px', '2xl': '15px' }}
                fontWeight={500}
                color={linkColor}
                transition={'0.3s ease-in-out'}
                position={'relative'}
                fontFamily={'Poppins'}
                _hover={{
                  color: '#fff',
                  _before: {
                    transform: 'scaleX(1)',
                    transformOrigin: 'bottom left',
                  }
                }}
                _before={{
                  content: `""`,
                  position: 'absolute',
                  w: '100%',
                  h: '2px',
                  transform: 'scaleX(0)',
                  bottom: '10px',
                  left: '0px',
                  borderRadius: '25px',
                  backgroundColor: "#fff",
                  transformOrigin: 'bottom right',
                  transition: 'transform 0.3s ease-in-out'
                }}>
                {navItem.Title}
                {
                  navItem?.icon &&
                  <Icon as={navItem?.icon} marginBottom={'-0.5'} />
                }
              </Link>
            </PopoverTrigger>

            {navItem.children?.length > 0 && (
              <PopoverContent
                className={`${navItem.Title}custom`}
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={2}
                rounded={'base'}
                minW={'base'}>
                <Stack>
                  {navItem.children?.map((child) => (
                    <DesktopSubNav subKey={i} key={child.Title} {...child} project={'service'} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
      {totalNavItems3?.map((navItem, i) => (
        <Box key={navItem.Title}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Link
                p={{ base: 1 }}
                py={{ base: 5 }}
                as={ReactLink}
                to={navItem.Id ?? '#'}
                fontSize={{ base: '12px', xl: '12px', '2xl': '15px' }}
                fontWeight={500}
                color={linkColor}
                transition={'0.3s ease-in-out'}
                position={'relative'}
                fontFamily={'Poppins'}
                _hover={{
                  color: '#fff',
                  _before: {
                    transform: 'scaleX(1)',
                    transformOrigin: 'bottom left',
                  }
                }}
                _before={{
                  content: `""`,
                  position: 'absolute',
                  w: '100%',
                  h: '2px',
                  transform: 'scaleX(0)',
                  bottom: '10px',
                  left: '0px',
                  borderRadius: '25px',
                  backgroundColor: "#fff",
                  transformOrigin: 'bottom right',
                  transition: 'transform 0.3s ease-in-out'
                }}>
                {navItem.Title}
                {
                  navItem?.icon &&
                  <Icon as={navItem?.icon} marginBottom={'-0.5'} />
                }
              </Link>
            </PopoverTrigger>

            {navItem.children?.length > 0 && (
              <PopoverContent
                className={`${navItem.Title}custom`}
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={2}
                rounded={'base'}
                minW={'base'}>
                <Stack>
                  {navItem.children?.map((child) => (
                    <DesktopSubNav subKey={i} key={child.Title} {...child} project={'project'} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
      {totalNavItems4?.map((navItem, i) => (
        <Box key={navItem.Title}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Link
                p={{ base: 1 }}
                py={{ base: 5 }}
                as={ReactLink}
                to={navItem.Id ?? '#'}
                fontSize={{ base: '12px', xl: '12px', '2xl': '15px' }}
                fontWeight={500}
                color={linkColor}
                transition={'0.3s ease-in-out'}
                position={'relative'}
                fontFamily={'Poppins'}
                _hover={{
                  color: '#fff',
                  _before: {
                    transform: 'scaleX(1)',
                    transformOrigin: 'bottom left',
                  }
                }}
                _before={{
                  content: `""`,
                  position: 'absolute',
                  w: '100%',
                  h: '2px',
                  transform: 'scaleX(0)',
                  bottom: '10px',
                  left: '0px',
                  borderRadius: '25px',
                  backgroundColor: "#fff",
                  transformOrigin: 'bottom right',
                  transition: 'transform 0.3s ease-in-out'
                }}>
                {navItem.Title}
                {
                  navItem?.icon &&
                  <Icon as={navItem?.icon} marginBottom={'-0.5'} />
                }
              </Link>
            </PopoverTrigger>

            {navItem.children?.length > 0 && (
              <PopoverContent
                className={`${navItem.Title}custom`}
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={2}
                rounded={'base'}
                minW={'base'}>
                <Stack>
                  {navItem.children?.map((child) => (
                    <DesktopSubNav subKey={i} key={child.Title} {...child} project={'simple'} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  );
};

const DesktopSubNav = ({ Name, Id, subLabel, project }) => {
  // console.log(Name);
  return (
    <>
      {
        // String(Id).split('.')[3] == 'pdf' ?
        //   <a href={Id} target="_blank" style={{ fontWeight: '500' }}>{Name}</a>
        //   :
        <Link
          as={ReactLink}
          to={project === 'project' ? `/project/${Id}` : project === 'simple' ? `${Id}` : `/service/${Id}`}
          role={'group'}
          display={'block'}
          px={2}
          py={1}
          rounded={'base'}
          _hover={{ bg: '#1FBDD0', color: '#fff' }}>
          <Stack direction={'row'} align={'center'}>
            <Box>
              <Text
                transition={'all .3s ease'}
                _groupHover={{ color: 'primaryHeading.100' }}
                fontWeight={500}>
                {Name}
              </Text>
              <Text fontSize={'sm'}>{subLabel}</Text>
            </Box>
            <Flex
              transition={'all .3s ease'}
              transform={'translateX(-10px)'}
              opacity={0}
              _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
              justify={'flex-end'}
              align={'center'}
              flex={1}>
              <Icon color={'primaryHeading.100'} w={5} h={5} as={ChevronRightIcon} />
            </Flex>
          </Stack>
        </Link>
      }
    </>

  );
};

const MobileNav = ({ totalNavItems1, totalNavItems2, totalNavItems3, totalNavItems4, }) => {
  return (
    <Stack
      bg={useColorModeValue('white', 'gray.800')}
      p={4}
      display={{ lg: 'none' }}
      mt={5}
    >
      {totalNavItems1?.map((navItem) => (
        <MobileNavItem key={navItem.Title} {...navItem} project={'simple'} />
      ))}
      {totalNavItems2?.map((navItem) => (
        <MobileNavItem key={navItem.Title} {...navItem} project={'service'} />
      ))}
      {totalNavItems3?.map((navItem) => (
        <MobileNavItem key={navItem.Title} {...navItem} project={'project'} />
      ))}
      {totalNavItems4?.map((navItem) => (
        <MobileNavItem key={navItem.Title} {...navItem} project={'simple'} />
      ))}
    </Stack>
  );
};

const MobileNavItem = ({ Title, children, Id, project }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        onClick={() => { children === undefined ? document.getElementById('hamb').click() : console.log('') }}
        py={2}
        as={ReactLink}
        to={Id ?? '#'}
        justify={'space-between'}
        align={'center'}
        _hover={{
          textDecoration: 'none',
        }}>
        <Text
          fontWeight={600}
          color={useColorModeValue('gray.600', 'gray.200')}>
          {Title}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={'all .25s ease-in-out'}
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={6}
            h={6}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}>
          {children &&
            children?.map((child) => (
              <Link onClick={() => { document.getElementById('hamb').click() }} key={child.Title} py={2} as={ReactLink} to={project === 'project' ? `/project/${child?.Id}` : project === 'simple' ? `${child?.Id}` : `/service/${child?.Id}`}>
                {child.Name}
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

// interface NavItem {
//   label: string;
//   subLabel?: string;
//   children?: Array<NavItem>;
//   href?: string;
// }

// const NAV_ITEMS = [
//   {
//     label: 'Home',
//     href: '/',
//   },
//   {
//     label: 'About Us',
//     children: [
//       {
//         label: 'Introduction',
//         href: '/about',
//       },
//       {
//         label: 'Chairman Message',
//         href: '/about/chairman',
//       },
//       {
//         label: 'Philosophy',
//         href: '/about/philosophy',
//       },
//       {
//         label: 'Vision',
//         href: '/about/vision',
//       },

//     ],
//     icon: HiChevronDown
//   },
//   {
//     label: 'Services',
//     children: [
//       {
//         label: 'Hifz / Nazra',
//         href: '/services/hifz-nazra',
//       },
//       {
//         label: 'Qaida / Schooling',
//         href: '/services/qaida-schooling',
//       },
//       {
//         label: 'Dars-e-nazami',
//         href: '/services/dars-e-nizami',
//       },
//       {
//         label: 'Family Adoption',
//         href: '/services/family-adoption',
//       },
//       {
//         label: 'Collective Qurbani',
//         href: '/services/collective-qurbani',
//       },
//       {
//         label: 'Tajheez-o-takfeen',
//         href: '/services/tajheez-o-takfeer',
//       },
//       {
//         label: 'Nai Zindagi',
//         href: '/services/nai-zindagi',
//       },
//       {
//         label: 'Dastarkhwan',
//         href: '/services/darterkhwan',
//       },
//       {
//         label: 'Provide Rashan',
//         href: '/services/ration',
//       },
//       {
//         label: 'Eid Package',
//         href: '/services/eid-package',
//       },
//       {
//         label: 'Ramadhan Package',
//         href: '/services/ramadhan-package',
//       },
//       {
//         label: 'Renovate Masjid/Islami School',
//         href: '/services/renovate-masjid',
//       },
//       {
//         label: 'RO Plant',
//         href: '/services/ro-plant',
//       },
//       {
//         label: 'Online Istekhara',
//         href: '/services/istekhara',
//       },
//       {
//         label: 'Online Sadaqah',
//         href: '/services/saqaqah',
//       },
//       {
//         label: 'Aqiqah',
//         href: '/services/Aqiqah',
//       },
//     ],
//     icon: HiChevronDown
//   },
//   {
//     label: 'Future Projects',
//     children: [
//       {
//         label: 'University',
//         href: '/future-projects/university',
//       },
//       {
//         label: 'City',
//         href: '/future-projects/city',
//       },
//       {
//         label: 'Job Bank',
//         href: '/future-projects/job-bank',
//       },
//       {
//         label: 'Online Quran Admission',
//         href: '/future-projects/online-quran-admission',
//       },
//       {
//         label: 'Quran App/Tafteesh',
//         href: '/future-projects/quran-app',
//       },
//       {
//         label: 'Blood Bank & Thalassemia center',
//         href: '/future-projects/blood-bank',
//       },
//       {
//         label: 'Clinic',
//         href: '/future-projects/clinic',
//       },
//     ],
//     icon: HiChevronDown
//   },
//   {
//     label: 'Audit Report',
//     children: [
//       {
//         label: 'Audit Report 2015',
//         href: '/',
//       },
//       {
//         label: 'Audit Report 2016',
//         href: '/',
//       },
//       {
//         label: 'Audit Report 2017',
//         href: '/',
//       },
//       {
//         label: 'Audit Report 2018',
//         href: '/',
//       },
//     ],
//     icon: HiChevronDown
//   },
//   {
//     label: 'Tax Docs',
//     children: [
//       {
//         label: 'Tax Exemption 2023 Certificate',
//         href: '/',
//       },
//       {
//         label: 'Tax Exemption 2022 Certificate',
//         href: '/',
//       },
//       {
//         label: 'Tax Exemption 2021 Certificate',
//         href: '/',
//       },
//       {
//         label: 'Tax Exemption 2020 Certificate',
//         href: '/',
//       },
//       {
//         label: 'Tax Exemption 2019 Certificate',
//         href: '/',
//       },
//       {
//         label: 'Tax Exemption 2018 Certificate',
//         href: '/',
//       },
//       {
//         label: 'Tax Exemption 2017 Certificate',
//         href: '/',
//       },
//     ],
//     icon: HiChevronDown
//   },
//   {
//     label: 'Media',
//     children: [
//       {
//         label: 'Photo Gallery',
//         href: '/media/photo-gallery',
//       },
//       {
//         label: 'Video Gallery',
//         href: '/media/video-gallery',
//       },
//       {
//         label: 'Press Releases',
//         href: '/media/press-release',
//       },
//       // {
//       //   label: 'Photo Releases',
//       //   href: '/',
//       // },
//       {
//         label: 'Downloads',
//         href: '/downloads',
//       },
//     ],
//     icon: HiChevronDown
//   },
//   {
//     label: 'News',
//     href: '/news',
//   },
//   {
//     label: 'Donate',
//     children: [
//       {
//         label: 'Donate Online Now',
//         href: '/online-donate',
//       },
//       {
//         label: 'Bank Details',
//         href: '/wire-transfer',
//       },
//       {
//         label: 'Cash & Cross Cheque',
//         href: '/cashAndCheque',
//       },
//     ],
//     icon: HiChevronDown
//   },
//   {
//     label: 'Contact us',
//     href: '/contact'
//   },
// ];
